import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import AccordionSectionPanel from "@insite/mobius/AccordionSection/AccordionSectionPanel";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    headerProps: {
        css: css`
            button {
                &:focus {
                    border-color: rgb(204, 204, 204);
                    border-width: 1px;
                }
            }
            ${/* sc-selector */ AccordionSectionPanel} + & button {
                &:focus {
                    border-color: rgb(204, 204, 204);
                    border-width: 1px;
                }
            }
        `,
    },
};
